import { ITableMetadata } from '../interfaces/common.interface';
import { EventTitleEnum } from '../enums/common.enum';

export const initialMetadataState: ITableMetadata = {
  currentPage: 1,
  itemsPerPage: 10,
  totalItems: 0,
  totalPages: 0
};

export const MESSAGE_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error'
};

export enum CustomErrorStatus {
  MISSING_EXCEL_VALUE = 'MISSING_EXCEL_VALUE',
  USER_EMAIL_ALREADY_EXISTS = 'USER_EMAIL_ALREADY_EXISTS',
  CHILD_ALREADY_EXISTS = 'CHILD_ALREADY_EXISTS',
  TEACHER_NOT_ACTIVE = 'TEACHER_NOT_ACTIVE',
  CHILD_NOT_ACTIVE = 'CHILD_NOT_ACTIVE'
}

export const HIDE_CHILD_EVENTS: EventTitleEnum[] = [
  EventTitleEnum.SLEEP,
  EventTitleEnum.MAIN_ACTIVITY,
  EventTitleEnum.CHILD_INTERACTION,
  EventTitleEnum.OTHER_KIDS,
  EventTitleEnum.MOOD
];
